var map = {
	"./computer/Block/Block.vue": [
		"ad75",
		"chunk-13d0ff4e"
	],
	"./mobile/Block/Block.vue": [
		"f9a5",
		"chunk-70cdec90"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4d44";
module.exports = webpackAsyncContext;